import '../scss/async-search.scss'; // eslint-disable-line import/no-relative-parent-imports
import { type Component, createApp } from 'vue';
import FundingProgramsListApp from './vue/FundingProgramsList.vue';
import JobsListApp from './vue/JobsList.vue';
import FaqListApp from './vue/FaqList.vue';
import NewsListApp from './vue/NewsList.vue';
import PublicationApp from './vue/PublicationList.vue';
import EmployeesListApp from './vue/EmployeesList.vue';
import EventCalendarApp from './vue/EventCalendar.vue';
import SearchListApp from './vue/SearchList.vue';
import PrimeVue from 'primevue/config';

function turnElementIntoApp (elementId: string, app: Component): void {
    const element = document.getElementById(elementId);
    if (element) {
        const createdApp = createApp(app, {
            endpoint: `${window.location.protocol}${window.location.host}${element.dataset.endpoint ?? ''}`,
            pluginNamespace: element.dataset.pluginNamespace,
            arguments: element.dataset.arguments,
            allowedFacets: element.dataset.allowedFacets,
            searchDomain: element.dataset.searchDomain
        });

        if (elementId === 'faq-list') {
            createdApp.use(PrimeVue);
            createdApp.provide(
                'pageUrl', element.dataset.pageUrl
            );
        }

        createdApp.provide('i18n', JSON.parse(element.dataset.i18n ?? '{}'));
        if ('languageId' in element.dataset) {
            createdApp.provide('locale', element.dataset.languageId === '1' ? 'en-US' : 'de-AT');
        }
        createdApp.mount(element);
    }
}

turnElementIntoApp('funding-programs-list', FundingProgramsListApp);
turnElementIntoApp('jobs-list', JobsListApp);
turnElementIntoApp('faq-list', FaqListApp);
turnElementIntoApp('news-list', NewsListApp);
turnElementIntoApp('publication-list', PublicationApp);
turnElementIntoApp('employees-list', EmployeesListApp);
turnElementIntoApp('event-calendar', EventCalendarApp);
turnElementIntoApp('search-list', SearchListApp);
